function joinUrlSegments(a, b) {
  if (!a || !b)
    return a || b || "";
  if (a[a.length - 1] === "/")
    a = a.substring(0, a.length - 1);
  if (b[0] !== "/")
    b = `/${b}`;
  return a + b;
}
function removeLeadingSlash(str) {
  return str[0] === "/" ? str.slice(1) : str;
}
function stripBase(path, base) {
  if (path === base)
    return "/";
  const devBase = withTrailingSlash(base);
  return path.startsWith(devBase) ? path.slice(devBase.length - 1) : path;
}
function withTrailingSlash(path) {
  if (path[path.length - 1] !== "/")
    return `${path}/`;
  return path;
}
function withLeadingSlash(path) {
  if (path[0] !== "/")
    return `/${path}`;
  return path;
}

export { withTrailingSlash as a, joinUrlSegments as j, removeLeadingSlash as r, stripBase as s, withLeadingSlash as w };
